import { Helmet } from "react-helmet";
import { SITE_URL } from "./App";
import SalaryTaxCalculator from "./SalaryTaxCalculator";

export default function TaxCalculator() {
  return (
    <>
      <Helmet>
        <title>Salary Tax Calculator Pakistan | Axis Compliance Solutions</title>
        <meta
          name="description"
          content="Use Axis Compliance Solutions' Pakistan salary tax calculator to estimate single-year monthly tax or multi-year total tax from FY 2019-20 to FY 2026-27."
        />
        <meta
          name="keywords"
          content="salary tax calculator Pakistan, tax calculator Pakistan, monthly salary tax Pakistan, income tax calculator Pakistan, salaried person tax Pakistan"
        />
        <link rel="canonical" href={`${SITE_URL}/tax-calculator`} />
        <meta property="og:title" content="Salary Tax Calculator Pakistan | Axis Compliance Solutions" />
        <meta
          property="og:description"
          content="Estimate Pakistan salary tax, monthly deduction, take-home salary, effective tax rate and multi-year total tax."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/tax-calculator`} />
        <meta property="og:image" content={`${SITE_URL}/axis-logo.png`} />
        <meta property="og:image:alt" content="Axis Compliance Solutions salary tax calculator" />
        <meta name="twitter:title" content="Salary Tax Calculator Pakistan | Axis Compliance Solutions" />
        <meta
          name="twitter:description"
          content="Estimate Pakistan single-year monthly salary tax and multi-year total tax from FY 2019-20 to FY 2026-27."
        />
        <meta name="twitter:image" content={`${SITE_URL}/axis-logo.png`} />
        <meta name="twitter:image:alt" content="Axis Compliance Solutions salary tax calculator" />
      </Helmet>

      <SalaryTaxCalculator />
    </>
  );
}
